import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import { privacyPolicyData } from '../Common/PrivacyPolicyData';
import { useEffect, useState } from 'react';
import FeedbackPopup from '../Common/FeedbackPopup';
import FooterComponent from '../Common/FooterComponent';
import ExtensionNavbar from './SlidesExtensionNavbar';
import { slidesExtensionPrivacyPolicyData } from '../Common/SlidesExtensionPrivacyPolicyData';
import SlidesFooterComponent from '../Common/SlidesFooterComponent';

function SlidesExtensionPrivacyPolicy(){

    const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);

    const isShowConsole = process.env.NODE_ENV === 'development';

    const location = useLocation();
    isShowConsole && console.log("Current Path:", location.pathname); 

    useEffect(() => {
        document.title = "Privacy Policy | Convert PDF to Google Slides";

        const ogTitle = document.querySelector('meta[property="og:title"]');
        if (ogTitle) {
            ogTitle.setAttribute('content', 'Privacy Policy | Convert PDF to Google Slides');
        }

    }, []);
    
    const privacyPolicyEle = slidesExtensionPrivacyPolicyData.map((ele, idx) => {
        return(
            <div className='ppEle' key={idx}>
                <div className='ppHeader'>{ele.header}</div>
                <div className='ppContent'>{ele.content}</div>
            </div>
        )
    });

    return(
        <div className='parentDiv'>
            <div className='mainDiv privacyPolicy'>
                <div className='header'>
                    <ExtensionNavbar />
                </div>
                <div className='contentDiv'>
                    <div className='containerDiv'>
                        <div className='title'>Privacy Policy</div>
                        <div className='contentBox'>
                            <div className='content'>
                                {privacyPolicyEle}
                            </div>
                        </div>
                    </div>
                </div>
                {showFeedbackPopup && <FeedbackPopup closeFeedbackPopup={() => setShowFeedbackPopup(false)}/>}
            </div>
            <SlidesFooterComponent forSheetsExtension={true} setShowFeedbackPopup={setShowFeedbackPopup}/>
        </div>
    )
}

export default SlidesExtensionPrivacyPolicy;